import React from "react";
import { connect } from "react-redux";
import { ActivityContainerStyled } from "./styled";
import { withRouter } from "navigations/withRouter";
import { ROUTE_PATH } from "utils/constants/routePath";
import { scrollToTopPageFN } from "utils/functions/scrollTopPage";
import { portalService } from "apiServices";
import { MdAdd, MdAssignmentAdd } from "react-icons/md";
import { RenderCommaMoney } from "utils/functions/FormatMoney";
import { ACTIVITY_RENDER_TYPE } from "utils/functions/activity";
import { RENDER_CHARACTER_REPLACE_BY_PERMISSION } from "utils/functions/string";
import * as XLSX from "xlsx";
import moment from "moment";
import momentTZ from "moment-timezone";
import queryString from "query-string";
import { Buttons, Displays, Inputs, Tables } from "components";
import { PARSE_LIST_QUERY } from "utils/functions/listQuery";
import {
  BUSINESS_UNIT_MAP,
  RENDER_BUSINESS_UNIT_NAME,
} from "utils/functions/businessUnit";

class ActivityContainer extends React.Component {
  state = {
    isLoading: true,
    pagination: null,
    perPage: 10,
  };

  componentDidMount() {
    const { perPage } = this.state;
    scrollToTopPageFN();
    const query = this.props.router.location.search || `?limit=${perPage}`;
    this.setState(PARSE_LIST_QUERY(this.props.router.location.search, perPage));
    this.fetchData(query);
  }

  fetchData = async (stringQuery) => {
    let resArr = await Promise.all([
      portalService.GET_ACTIVITY_LIST(stringQuery),
      portalService.GET_BUSINESS_UNIT_LIST(
        `?pagination=false&is_deleted=false`
      ),
    ]);
    if (resArr && resArr[0].status === 200) {
      this.setState({
        businessUnitMap: BUSINESS_UNIT_MAP(resArr[1]?.data?.docs),
        businessUnitOptions: [
          { label: "All", value: "" },
          { label: "None", value: "null" },
          ...resArr[1].data.docs.map((e) => ({
            label: e.name,
            value: e._id,
          })),
        ],
        data: resArr[0].data.docs,
        isLoading: false,
        pagination: {
          last_page: resArr[0].data.totalPages,
          current_page: resArr[0].data.page,
          total: resArr[0].data.totalDocs,
          per_page: resArr[0].data.limit,
        },
      });
    }
  };

  handleFilterKeyword = (e) => {
    const { perPage } = this.state;
    this.setState({
      filterQuery: e,
    });
    this.handleJoinQuery(e, perPage, 1);
  };

  handlePageClick = (e) => {
    const { filterQuery, perPage } = this.state;
    this.handleJoinQuery(filterQuery, perPage, e.selected + 1);
  };

  handlePerPageChange = (perPage) => {
    const { filterQuery } = this.state;
    this.setState({ perPage });
    this.handleJoinQuery(filterQuery, perPage, 1);
  };

  handleTogglePin = (id) => {
    console.log(`Pinned status of ${id}:`);
  };

  handleJoinQuery = (query, per_page, page) => {
    let joinQuery = query
      ? `${query}&limit=${per_page}&page=${page}`
      : `?limit=${per_page}&page=${page}`;
    this.setState({
      isLoading: true,
    });
    this.props.router.navigate(`${ROUTE_PATH.ACTIVITY}${joinQuery}`);
    this.fetchData(joinQuery);
  };

  handleClickCreate = (e) => {
    this.props.router.navigate(`${ROUTE_PATH.ACTIVITY}/${e}`);
  };

  // กิจกรรมจองที่นั่งมีหน้าจัดการของตัวเอง (ที่นั่ง/ตรวจสลิป) กิจกรรมอื่นไปหน้าผู้เข้าร่วมเดิม
  handleClickOfflineActivity = (activity) => {
    this.props.router.navigate(
      activity.is_seat_booking
        ? `${ROUTE_PATH.ACTIVITY}/seat/${activity._id}`
        : `${ROUTE_PATH.ACTIVITY}/offline/${activity._id}`
    );
  };

  handleExport = async (permission) => {
    const { filterQuery } = this.state;
    this.setState({
      isBgLoading: true,
    });
    let joinQuery = filterQuery
      ? `${filterQuery}&pagination=false`
      : `?pagination=false`;
    let res = await portalService.GET_ACTIVITY_LIST(joinQuery);
    if (res && res.status === 200) {
      let wb = XLSX.utils.book_new();
      let ws_name = "SheetJS";
      /* make worksheet */
      let ws_data = res.data.docs.reduce((result, e, i) => {
        result.push([
          i + 1,
          momentTZ(e.created_at).tz("Asia/Bangkok").format("DD/MM/YYYY"),
          e.code,
          RENDER_CHARACTER_REPLACE_BY_PERMISSION({
            ...permission,
            inputString: e.name,
            action: "export",
          }),
          ACTIVITY_RENDER_TYPE(e.type),
          e.point,
        ]);
        return result;
      }, []);
      ws_data.splice(0, 0, [
        "No",
        "Create Date",
        "Code",
        "Name",
        "Type",
        "Point",
      ]);
      let ws = XLSX.utils.aoa_to_sheet(ws_data);
      let wscols = [
        { wch: 5 },
        { wch: 15 },
        { wch: 30 },
        { wch: 30 },
        { wch: 15 },
        { wch: 15 },
      ];
      ws["!cols"] = wscols;
      /* Add the worksheet to the workbook */
      XLSX.utils.book_append_sheet(wb, ws, ws_name);
      XLSX.writeFile(
        wb,
        `activity-report-${moment()
          .tz("Asia/Bangkok")
          .format("DD/MM/YYYY")}.xlsx`
      );
      this.setState({
        isBgLoading: false,
      });
    }
  };

  render() {
    const { authenRedux, router } = this.props;
    const {
      isLoading,
      isBgLoading,
      businessUnitOptions,
      businessUnitMap,
      pagination,
      data,
    } = this.state;
    const permission = !authenRedux
      ? false
      : authenRedux?.permission.find((e) => e.menu_key === "activity");
    return (
      <ActivityContainerStyled>
        <Displays.BGLoading visible={isBgLoading} />
        {permission && permission.is_create && (
          <div className="btn_create">
            <div className="w120">
              <Buttons.BgIconPrefix
                label="New"
                icon={<MdAdd size={18} />}
                onClick={() => this.handleClickCreate("create")}
              />
            </div>
          </div>
        )}
        {businessUnitOptions && (
          <Inputs.InputFilter
            theme_standard_input_filter
            dataFilter={dataFilter(
              router.location?.search,
              businessUnitOptions
            )}
            btnLabel="ค้นหา"
            onQueryFilter={this.handleFilterKeyword}
            onExport={
              permission &&
              (permission.is_export || permission.is_export_condition)
                ? () => this.handleExport(permission)
                : false
            }
          />
        )}
        {isLoading ? (
          <Displays.Loading theme_standard_loading heightLayout="324px" />
        ) : (
          <>
            <div className="body_table  ">
              <Tables.Standard
                columns={columns({
                  businessUnitMap,
                  handleClickDetail: this.handleClickCreate,
                  handleClickOfflineActivity: this.handleClickOfflineActivity,
                  handleTogglePin: this.handleTogglePin,
                })}
                data={data}
                showPagination
                pagination={pagination}
                handlePageClick={this.handlePageClick}
                onChangePerPage={this.handlePerPageChange}
              />
            </div>
          </>
        )}
      </ActivityContainerStyled>
    );
  }
}

const dataFilter = (query, businessUnitOptions) => {
  let initialValues = queryString.parse(query);
  return [
    {
      accessor: "keyword",
      length: "311px",
      filter: {
        fieldQuery: "keyword",
        defaultValue: initialValues["keyword"],
        type: "text",
        label: "Search",
        placeholder: "Code / Name",
      },
    },
    {
      accessor: "type",
      length: "311px",
      filter: {
        fieldQuery: "type",
        defaultValue: initialValues["type"],
        type: "dropdown",
        label: "Type",
        placeholder: "Select type",
        options: [
          {
            label: "Online",
            value: "1",
          },
          {
            label: "Offline",
            value: "2",
          },
        ],
      },
    },
    {
      accessor: "business_unit_id",
      length: "311px",
      filter: {
        fieldQuery: "business_unit_id",
        defaultValue: initialValues["business_unit_id"],
        type: "dropdown",
        label: "Business Unit",
        placeholder: "Select Business Unit",
        options: businessUnitOptions || [],
      },
    },
  ];
};

const columns = ({
  businessUnitMap,
  handleClickDetail,
  handleClickOfflineActivity,
}) => [
  {
    Header: <div style={{ textAlign: "left" }}>Create Date</div>,
    accessor: "created_at",
    Cell: (props) => (
      <div onClick={() => handleClickDetail(props.row.original._id)}>
        {momentTZ(props.value).tz("Asia/Bangkok").format("DD/MM/YYYY HH:mm")}
      </div>
    ),
  },
  {
    Header: <div style={{ textAlign: "left" }}>Code</div>,
    accessor: "code",
    Cell: (props) => (
      <div onClick={() => handleClickDetail(props.row.original._id)}>
        {props.value}
      </div>
    ),
  },
  {
    Header: <div style={{ textAlign: "left" }}>Name</div>,
    accessor: "short_title_th",
    Cell: (props) => (
      <div onClick={() => handleClickDetail(props.row.original._id)}>
        {props.value}
      </div>
    ),
  },
  {
    Header: <div style={{ textAlign: "left" }}>Business Unit</div>,
    accessor: "business_unit_ref_id",
    Cell: (props) => (
      <div onClick={() => handleClickDetail(props.row.original._id)}>
        {RENDER_BUSINESS_UNIT_NAME(businessUnitMap, props.value)}
      </div>
    ),
  },
  {
    Header: <div style={{ textAlign: "left" }}>ชนิด</div>,
    accessor: "type",
    Cell: (props) => (
      <div onClick={() => handleClickDetail(props.row.original._id)}>
        {ACTIVITY_RENDER_TYPE(props.value)}
      </div>
    ),
  },
  {
    Header: <div style={{ textAlign: "left" }}>คะแนน</div>,
    accessor: "point",
    Cell: (props) => (
      <div onClick={() => handleClickDetail(props.row.original._id)}>
        {RenderCommaMoney(props.value, true)}
      </div>
    ),
  },
  {
    Header: <div style={{ textAlign: "left" }}>Active</div>,
    accessor: "is_active",
    Cell: (props) => (
      <div onClick={() => handleClickDetail(props.row.original._id)}>
        {props.value ? (
          <Displays.StatusLabel bg={"green"} label={"ทำงาน"} />
        ) : (
          <Displays.StatusLabel bg={"#FFB341CC"} label={"ไม่ทำงาน"} />
        )}
      </div>
    ),
  },
  {
    Header: <div style={{ textAlign: "left" }}>Action</div>,
    accessor: "action",
    Cell: (props) => (
      <div onClick={() => handleClickOfflineActivity(props.row.original)}>
        <MdAssignmentAdd size={22} color="#4b1e78" />
      </div>
    ),
  },
  {
    Header: <div style={{ textAlign: "left" }}>Pinned</div>,
    accessor: "is_pin",
    Cell: (props) => (
      <div onClick={() => handleClickDetail(props.row.original._id)}>
        {props.value ? (
          <Displays.StatusLabel bg={"green"} label={"Pin"} />
        ) : (
          <Displays.StatusLabel bg={"#FFB341CC"} label={"Unpin"} />
        )}
      </div>
    ),
  },
];

const mapStateToProps = (state) => ({
  authenRedux: state.authenRedux,
});

const mapDispatchToProps = (dispatch) => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(ActivityContainer));
